import { DEFAULT_LOCALE, SupportedLocale } from "./LocaleProvider";

/** 各語系可接受的網址參數寫法（大小寫不拘）。 */
const LOCALE_ALIASES: Record<string, SupportedLocale> = {
	zh: "zh-TW",
	"zh-tw": "zh-TW",
	"zh_tw": "zh-TW",
	tw: "zh-TW",
	"zh-hant": "zh-TW",
	en: "en",
	"en-us": "en",
};

/**
 * 把網址上的 lang 參數（如 ?lang=zh / ?lang=en）轉成支援的語系。
 * 認不得或沒帶 → 回傳 fallback（預設 en）。
 *
 * @example resolveLocale(searchParams.get("lang")) // "en" | "zh-TW"
 */
export function resolveLocale(
	rawLang: string | null | undefined,
	fallback: SupportedLocale = DEFAULT_LOCALE,
): SupportedLocale {
	if (!rawLang) {
		return fallback;
	}
	return LOCALE_ALIASES[rawLang.trim().toLowerCase()] ?? fallback;
}
